
const webUrl = process.env.REACT_APP_WEB_URL;
const localUrl = process.env.REACT_APP_LOCAL_URL;
const apiMode = process.env.REACT_APP_API_MODE;
export const requestUrl = apiMode === 'production' ? webUrl : localUrl;
export { webUrl, localUrl };
